import {
  ACCESS_TOKEN,
  DEFAULT_AUTH_TOKEN_ENDPOINT,
  ID_TOKEN,
  REFRESH_TOKEN
} from './client/constants';
import * as localStorage from './client/storage/localStorage';
import { oauthToken } from './client/util/utils';
import { isManagementViewEnabled } from '../utilities/EnvironmentUtility';

export async function getTokenFromRefreshToken(config = window.configuration) {
  const refresh_token = getRefreshToken();
  if (!refresh_token) {
    return false;
  }

  let authResult;
  try {
    authResult = await oauthToken(
      (config.authServerUrl || config.authIssuer) +
        (config.authTokenEndpoint || DEFAULT_AUTH_TOKEN_ENDPOINT),
      {
        grant_type: REFRESH_TOKEN,
        client_id: config.authClientId,
        refresh_token
      }
    );
  } catch (_: any) {
    return false;
  }

  if (!authResult.id_token) {
    return false;
  }

  if (isManagementViewEnabled() && !authResult.access_token) {
    return false;
  }

  localStorage.setItem(ID_TOKEN, authResult.id_token);
  if (authResult.access_token) {
    localStorage.setItem(ACCESS_TOKEN, authResult.access_token);
  }

  if (authResult.refresh_token) {
    localStorage.setItem(REFRESH_TOKEN, authResult.refresh_token);
  }

  return true;
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN);
}

export function getBearerHeader() {
  const accessToken = getAccessToken();
  return !accessToken ? {} : { Authorization: `Bearer ${accessToken}` };
}
